'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Digital Signature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'All About Digital Signatures',
            subtitle: 'Ready to start eSigning with HelloSign?',
            buttonText: 'IT\'S ALWAYS FREE TO TRY!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What is a digital signature?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'A digital signature refers to a set of algorithms and encryption protections used to determine the authenticity of a document or software.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'In simpler terms, a digital signature is a complicated way to verify that a document hasn\u2019t been tampered with during transit between sender and signer.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Does HelloSign provide digital signatures?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign provides ',
                _react2['default'].createElement(
                    'a',
                    { href: '/electronic-signature',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'electronic signatures'
                ),
                '. HelloSign electronic signatures are legally binding and protected with bank-level security. By and large, anyone requesting or signing a document is using an electronic signature. Our security ensures that all documents are kept secure and protected. These security features include:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Secure data storage'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'SSL hosting'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Audit-trails with time stamps'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Features like two-factor authentication'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can read more about the ',
                _react2['default'].createElement(
                    'a',
                    { href: '/info/security',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'legality and security of electronic signatures here'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do HelloSign electronic signatures work?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign electronic signatures allow you to legally sign documents online, send signature requests to others for signing, and track the progress of any document. Here are just some of the places you\u2019ll see electronic signatures used:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'NDAs and release forms'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Vendor paperwork and other complicated applications'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Proposals and sales contracts'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Happy users of HelloSign\u2019s electronic signatures include the BBB, Samsung, and Twitter.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Digital signature vs. electronic signature'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'While most people use the terms interchangeably, there is a difference between the two. An electronic signature refers to a protected and legally binding online signature. A digital signature refers to a complicated method for authenticating a document.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'For the most part, people are looking for an electronic signature when they\u2019re searching for digital signatures.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Who\u2019s using HelloSign signatures?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign integrates with different companies to make signing as simple and easy as possible. We\u2019re happy to partner with:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Google (including ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'https://www.hellosign.com/gmail',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Gmail'
                    ),
                    ', ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'https://www.hellosign.com/googledrive',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Google Drive'
                    ),
                    ', and ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://www.hellosign.com/google-docs-add-on', target: '_blank', rel: 'noopener noreferrer' },
                        'Google Docs'
                    ),
                    ')'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Evernote'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/dropbox/', target: '_blank', rel: 'noopener noreferrer' },
                        'Dropbox'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Slack'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Zapier'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'HubSpot CRM'
                    )
                )
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Now that you’re more familiar with electronic and digital signatures, try eSigning out for yourself! Or if you want to learn more about HelloSign eSignatures, schedule a live demo. We’ll walk you through our features and integrations.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/digital-signature.jsx
 ** module id = 1227
 ** module chunks = 0
 **/